import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    callbackData: [],
    selectedTab: "Inbox",
    counts: {
        inbox: 0,
        pending:0,
        cancelled:0,
        completed:0
    }
};

const callbackSlice = createSlice({
    name: "callbackSlice",
    initialState: initialState,
    reducers: {
        setCallbackData(state, action) {
            let payload = action.payload;
            state.callbackData = payload
        },
        setSelectedTab(state, action) {
            let payload = action.payload
            state.selectedTab = payload
        },
        setCounts(state, action) {
            let payload = action.payload;
            state.counts = payload;
        } 
    },
});

export const callbackSliceAction = callbackSlice.actions;
export default callbackSlice.reducer;